"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddCoinsToWinCounter = AddCoinsToWinCounter;
var _types = require("./types");
/**
 * Used to add win to a win counter. Used for custom feature handling mostly.
 * @param coins 
 * @returns 
 */
function AddCoinsToWinCounter(coins) {
  return {
    type: _types.GAME_WINCOUNTER_ADD,
    payload: coins
  };
}
//# sourceMappingURL=actions.js.map